import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { WaSelect } from '@wehunt/ui'
import { useAvailableDistricts } from './useAvailableDistricts'
import { useActiveDistrict } from '../../shared/auth/useActiveDistrict'
import { swedishCollator } from '../../shared/i18n/swedishCollator'

/**
 * District selector in the top bar. Hidden unless the user belongs to more than
 * one district. Switching sets the active district (persisted) and invalidates
 * all queries so data refetches under the new X-District-Id, and nav/gates
 * recompute from the new active role.
 */
export function DistrictSwitcher() {
  const { t } = useTranslation('common')
  const { data: districts } = useAvailableDistricts()
  const { activeDistrictId, setActiveDistrict } = useActiveDistrict()
  const queryClient = useQueryClient()

  if (!districts || districts.length < 2) return null

  // By name, as legacy listed the areas; the API returns them in membership order.
  const options = [...districts]
    .sort((a, b) => swedishCollator.compare(a.name, b.name))
    .map((d) => ({ value: d.id, label: d.name }))

  return (
    <WaSelect
      value={activeDistrictId ?? districts[0].id}
      options={options}
      ariaLabel={t('topbar.selectDistrict')}
      onChange={(id) => {
        setActiveDistrict(id)
        void queryClient.invalidateQueries()
      }}
    />
  )
}
